'use client';

// libraries
import Box from '@mui/material/Box';
import styled from 'styled-components';

interface IStyledBasicModal {
  width?: number;
  height?: number;
  useFooter?: boolean;
}

export const StyledBasicModal = styled(Box)<IStyledBasicModal>`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: ${(p) => (p.width ? p.width : null)};
  background-color: #fff;
  box-shadow: 0 0 3px 0 rgba(0, 0, 0, 0.15);
  border-radius: 12px;
  overflow: hidden;

  .modalHead {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 66px;
    padding: 0 20px 0 28px;
    font-size: 18px;
    font-weight: 600;
    border-bottom: 1px solid #e6e6e6;
    box-sizing: border-box;
  }

  .modalBody {
    padding: 25px 28px 12px 28px;
    height: ${(p) => (p.height ? (p.useFooter ? `${p.height - 180}px` : `${p.height}px`) : null)};
    overflow-y: auto;
  }

  .modalFoot {
    padding: 12px 28px;
    display: flex;
    align-items: center;
    justify-content: end;
    gap: 12px;
  }
`;
